// extracted by mini-css-extract-plugin
export default {"span":"TouchInput_span__e+e-m"};